export default {
      id: "microphone-input-usage",
      viewBox: "0 0 12 17",
      url: __webpack_public_path__ + "sprite.svg#microphone-input-usage",
      toString: function () {
        return this.url;
      }
    }